import {FormErrorBox} from "common/FormErrorBox"
import {useForm} from "react-hook-form"
import {useRootStore} from "store/useRootStore"
import {useEffect} from "react"
import {observer} from "mobx-react"
import {useUpdateEnvironmentMutation} from "hooks/queries/env.query"
import {Environment} from "dto/env/env"

interface ApplicationEnvironmentValues {
    mapKey?: string
    zoomLevel: number
    lat: string
    lng: string
    gradientX: number
    gradientY: number
    impactX: number
    impactY: number
}

export const EnvironmentForm = observer(() => {
    const {envStore} = useRootStore()
    const mutation = useUpdateEnvironmentMutation()
    const {register, formState: {errors}, setValue, handleSubmit} = useForm<ApplicationEnvironmentValues>()
    useEffect(() => {
        const env = envStore.env
        setValue("mapKey", env?.mapKey)
        setValue("impactX", env?.thresholdValues?.impactX || 0)
        setValue("impactY", env?.thresholdValues?.impactY || 0)
        setValue("gradientX", env?.thresholdValues?.gradientX || 0)
        setValue("gradientY", env?.thresholdValues?.gradientY || 0)
        setValue("lat", env?.center?.lat || "0")
        setValue("lng", env?.center?.lng || "0")
        setValue("zoomLevel", env?.zoomLevel || 0)
    }, [envStore.env, setValue])

    const onSubmit = (data: ApplicationEnvironmentValues) => {
        console.log("수정하시겠습니까? :", data)
        const env: Environment = {
            mapKey: data.mapKey,
            thresholdValues: {
                gradientX: data?.gradientX,
                gradientY: data?.gradientY,
                impactX: data.impactX || 0,
                impactY: data.impactY || 0
            },
            center: {
                lat: data.lat,
                lng: data.lng
            },
            zoomLevel: data.zoomLevel
        }
        mutation.mutate(env)
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="admin-container">
                <div className="level ">
                    <div className="level-left">
                        <h5 className="is-size-3 has-text-weight-bold">환경설정</h5>
                    </div>
                </div>

                <div className="admin-panel admin-body ">
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">지도 초기 줌 레벨</div>
                            <div className="column">
                                <input
                                    {...register("zoomLevel", {required: "지도의 초기 줌 레벨을 입력하세요"})}
                                    className="input" type="text" placeholder="지도 초기 줌 레벨"/>
                                <FormErrorBox error={errors.zoomLevel}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">위도</div>
                            <div className="column">
                                <input
                                    {...register("lat", {required: "위도를 입력하세요"})}
                                    className="input" type="text" placeholder="지도 초기 위도"/>
                                <FormErrorBox error={errors.lat}/>
                            </div>
                            <div className=" stitlebox label">경도</div>
                            <div className="column">
                                <input
                                    {...register("lng", {required: "경도를 입력하세요"})}
                                    className="input" type="text" placeholder="지도 초기 경도"/>
                                <FormErrorBox error={errors.lng}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0" style={{height: 0, visibility: 'hidden'}}>
                        <div className="column columns">
                            <div className=" stitlebox label">충격 기준값(X)</div>
                            <div className="column">
                                <input
                                    {...register("impactX", {required: "충격 기준값(X)을 입력하세요"})}
                                    className="input" type="text" placeholder="들어오는 충격값을 비교하여 위급상황으로 판단하는 기준"/>
                                <FormErrorBox error={errors.impactX}/>
                            </div>
                            <div className=" stitlebox label">충격 기준값(Y)</div>
                            <div className="column">
                                <input
                                    {...register("impactY", {required: "충격 기준값(Y)을 입력하세요"})}
                                    className="input" type="text" placeholder="들어오는 충격값을 비교하여 위급상황으로 판단하는 기준"/>
                                <FormErrorBox error={errors.impactY}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="columns mb0">
                        <div className="column columns">
                            <div className=" stitlebox label">기울기 기준값(X)</div>
                            <div className="column">
                                <input
                                    {...register("gradientX", {required: "기울기 기준값(X)을 입력하세요"})}
                                    className="input" type="text" placeholder="들어오는 기울기값을 비교하여 위급상황으로 판단하는 기준"/>
                                <FormErrorBox error={errors.gradientX}/>
                            </div>
                            <div className=" stitlebox label">기울기 기준값(Y)</div>
                            <div className="column">
                                <input
                                    {...register("gradientY", {required: "기울기 기준값(Y)을 입력하세요"})}
                                    className="input" type="text" placeholder="들어오는 기울기값을 비교하여 위급상황으로 판단하는 기준"/>
                                <FormErrorBox error={errors.gradientY}/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                    <div className="has-text-right">
                        <button className="button is-primary">저장</button>
                    </div>
                </div>
            </div>
        </form>
    )
})